<template>
  <div class="tw-w-full tw-space-y-1.5 tw-animate-pulse">
    <div class="tw-justify-between tw-flex game-link-color tw-font-bold">
      <loading-label />
      <loading-label />
    </div>
    <div class="tw-flex tw-h-1.5 game-primary-button-color"></div>
  </div>
</template>

<script>
import LoadingLabel from '@components/Loading/LoadingLabel.vue'
export default {
  components: {
    LoadingLabel,
  },
}
</script>
